import { defineStore } from "pinia"
import type { Image } from "~/models/image"
import type { ApiResponse } from "~/types/api"

// image :: upload image
export interface UploadImageResponse extends ApiResponse {
	data: Image
}
const UploadImage = {
	method: "POST" as const,
	url: () => "images/upload"
}

// image :: get image
export interface GetImageRequest {
	image: any
}
export interface GetImageResponse extends ApiResponse {
	data: Image
}
const GetImage = {
	method: "POST" as const,
	url: (id: number) => `images/${id}`
}

export const useImageApiUrl = () => ({
	UploadImage,
	GetImage
})

export const useImageStore = defineStore("image", () => {
	const state = {}

	const uploadImage = async (image: File, size?: number) => {
		const formData = new FormData()
		formData.set("image", image)
		if (size) formData.set("size", size.toString())
		const data = await $fetch<UploadImageResponse>(UploadImage.url(), {
			...useFetchConfig(),
			method: UploadImage.method,
			body: formData
		})
		return data.data
	}

	const getImage = async (id: number) => {
		const data = await $fetch<GetImageResponse>(GetImage.url(id), {
			...useFetchConfig(),
			method: GetImage.method
		})
		return data.data
	}

	return {
		...state,
		uploadImage,
		getImage
	}
})
